import React from 'react';
import { AuthContext } from '../../WebApp';

const pricingData = [
  {
    key: 'reply',
    title: 'AI Reply',
    titleRu: 'Ответ AI',
    price: '1 token',
    priceRu: '1 токен',
    description: 'Each chat reply from the model.',
    descriptionRu: 'Каждый ответ модели в чате.'
  },
  {
    key: 'photo',
    title: 'Photo Generation',
    titleRu: 'Генерация фото',
    price: '19 tokens',
    priceRu: '19 токенов',
    description: 'Create a new image of the model using reference seed.',
    descriptionRu: 'Создание нового изображения модели с сохранением внешности.'
  },
  {
    key: 'video',
    title: 'Video Generation',
    titleRu: 'Генерация видео',
    price: '99 tokens',
    priceRu: '99 токенов',
    description: 'Short motion clips generated from the reference image.',
    descriptionRu: 'Короткие видеоклипы, сгенерированные на основе референса.'
  },
  {
    key: 'character',
    title: 'Character Creation',
    titleRu: 'Создание персонажа',
    price: '39 tokens',
    priceRu: '39 токенов',
    description: 'Create your custom character with photo generation and moderation.',
    descriptionRu: 'Создание персонажа с генерацией фото и модерацией.'
  }
];

function Prices() {
  const { language } = React.useContext(AuthContext);
  const isRu = language === 'ru';

  return (
    <div className="max-w-4xl mx-auto py-10 px-4">
      <div className="bg-dark-800 border border-burgundy-900 rounded-2xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-white mb-2">
          {isRu ? 'Цены и лимиты' : 'Pricing & Limits'}
        </h1>
        <p className="text-gray-300 mb-8">
          {isRu
            ? 'Все операции оплачиваются токенами. Пополнить баланс можно через Telegram Stars или криптовалютой.'
            : 'All operations are paid with tokens. You can top up via Telegram Stars or crypto.'}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingData.map((item) => (
            <div
              key={item.key}
              className="bg-black/40 rounded-2xl border border-white/10 px-5 py-6 flex flex-col gap-2"
            >
              <div className="text-sm text-gray-400 uppercase tracking-widest">
                {isRu ? item.titleRu : item.title}
              </div>
              <div className="text-2xl font-semibold text-white">
                {isRu ? item.priceRu : item.price}
              </div>
              <p className="text-sm text-gray-300">
                {isRu ? item.descriptionRu : item.description}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs text-gray-400 text-center">
          {isRu
            ? 'Базовая цена: $8 = 1000 токенов. Специальная скидка: $5 = 1000 токенов (1$ = 200 токенов). После оплаты сумма в USD автоматически конвертируется в токены.'
            : 'Regular price: $8 = 1000 tokens. Special discount: $5 = 1000 tokens (1$ = 200 tokens). After payment the system converts USD to tokens automatically.'}
        </p>

      </div>
    </div>
  );
}

export default Prices;

